import {ActionReducer, combineReducers, MetaReducer} from '@ngrx/store';
import {bpmnXml} from '@ispm-client/modules/bpmn-modeler/store/reducer/bpmn-xml.reducer';
import {CORE_ACTIONS} from '@ispm/core/constants/core-actions.constant';
import {nodesCreationInfo} from '@ispm-client/modules/bpmn-modeler/store/reducer/node.reducer';
import {bpmnXmlGenerationError} from '@ispm-client/modules/bpmn-modeler/store/reducer/bpmn-xml-failure.reducer';
import {nodeConfigurations} from '@ispm-client/modules/bpmn-modeler/store/reducer/node-configurations.reducer';
import {bpmnIdentifier} from '@ispm-client/modules/bpmn-modeler/store/reducer/bpmn-identifier.reducer';
import {bpmnDeploymentError} from '@ispm-client/modules/bpmn-modeler/store/reducer/bpmn-identifires-error.reducer';
import {saveParams} from '@ispm-client/modules/bpmn-modeler/store/reducer/save-params.reducer';
import {modelerState} from '@ispm-client/modules/bpmn-modeler/store/reducer/modeler-state.reducer';
import {lastNodeId} from '@ispm-client/modules/bpmn-modeler/store/reducer/node-id-generator.reducer';
import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {floatingNodesInfo} from '@ispm-client/modules/bpmn-modeler/store/reducer/floating-nodes.reducer';
import {
  activeNodeNotesPanel,
  nodesWithNotes
} from '@ispm-client/modules/bpmn-modeler/store/reducer/node-notes.reducer';
import {spinnerStatus} from '@ispm-client/modules/bpmn-modeler/store/reducer/spinner-status.reducer';
import {userInitiatedActions} from '@ispm-client/modules/bpmn-modeler/store/reducer//user-initiated-actions.reducer';
import {modelerContext} from '@ispm-client/modules/bpmn-modeler/store/reducer/modeler-context.reducer';
import {nodeConfigurationPanelState} from '@ispm-client/modules/bpmn-modeler/store/reducer/node-configurtaion-panel.reducer';
import {explorerViewCommand} from '@ispm-client/modules/bpmn-modeler/store/reducer/explorer-view.reducer';

const combinedReducers = {
  nodesCreationInfo: nodesCreationInfo,
  bpmnXml: bpmnXml,
  bpmnXmlGenerationError: bpmnXmlGenerationError,
  nodeConfigurations: nodeConfigurations,
  bpmnIdentifier: bpmnIdentifier,
  bpmnDeploymentError: bpmnDeploymentError,
  saveParams: saveParams,
  modelerState: modelerState,
  lastNodeId: lastNodeId,
  floatedNodes: floatingNodesInfo,
  nodesWithNotes: nodesWithNotes,
  activeNodeNotesPanel: activeNodeNotesPanel,
  spinnerStatus: spinnerStatus,
  userInitiatedActions: userInitiatedActions,
  modelerContext: modelerContext,
  nodeConfigurationPanelState: nodeConfigurationPanelState,
  explorerViewCommand: explorerViewCommand
};

const bpmnModelerMetaReducer = combineReducers(combinedReducers, initialState);

export function bpmnModelerMetaReducerA(state, action) {
  return bpmnModelerMetaReducer(state, action);
}

export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateReducer];
